import React from "react";
import "./CreateGroupDialog.css";
import { Badge, Button, Form, InputGroup, Table, Col } from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import TypeAheadInput from "../../../../components/typeahead/Typeahead";

class CreateGroupDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isGroupName,
      },
      members: {
        defaultValue: [],
        rule: ValidationHelper.isMemberArrayGroup,
      },
      description: {
        defaultValue: "",
        rule: ValidationHelper.isDescription,
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      newMemberEmail: "",
      newMemberUserId: "",
      newMemberValid: false,
      addedMembers: new Set(),
      clear: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
    this.handleAddMember = this.handleAddMember.bind(this);
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
    this.handleCheckEmail = this.handleCheckEmail.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition),
        newMemberEmail: "",
        newMemberUserId: "",
        newMemberValid: false,
        addedMembers: new Set(),
      });
    }
  }

  async handleCheckEmail(email) {
    if (ValidationHelper.isEmail(email)) {
      try {
        const foundMembers = this.props.users.filter(
          (user) => user.email === email
        );
        if (foundMembers.length > 0) {
          this.setState({
            newMemberValid: true,
            newMemberEmail: foundMembers[0].email,
            newMemberUserId: foundMembers[0]._id,
          });
          return;
        }
      } catch (err) {}
    }
    this.setState({ newMemberValid: false });
  }

  handleAddMember() {
    if (
      this.state.newMemberValid &&
      this.state.newMemberUserId.length > 0 &&
      !this.state.addedMembers.has(this.state.newMemberEmail)
    ) {
      const updatedMembers = [
        {
          userId: this.state.newMemberUserId,
          email: this.state.newMemberEmail,
        },
        ...this.state.validation.members.value,
      ];
      const addedMembers = new Set(updatedMembers.map((s) => s.email));
      this.setState({
        addedMembers: addedMembers,
        validation: ValidationHelper.update(
          {
            target: {
              name: "members",
              value: updatedMembers,
            },
          },
          this.state.validation
        ),
      });
      this.setState({ newMemberEmail: "", clear: true });
    }
  }

  handleRemoveMember(member) {
    const updatedMembers = this.state.validation.members.value.filter(
      (mb) => mb.userId !== member.userId
    );
    const addedMembers = new Set(updatedMembers.map((s) => s.email));
    this.setState({
      addedMembers: addedMembers,
      validation: ValidationHelper.update(
        {
          target: {
            name: "members",
            value: updatedMembers,
          },
        },
        this.state.validation
      ),
    });
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
      const count = validatedData.members.length;
      this.props.handleCountMember(count);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Groups.GroupModal.CreateModalTitle")}
        dialogApiError={this.props.dialogApiError}
        leftButtonVariant="black"
        rightButtonVariant="green"
        rightButtonText={t("Groups.GroupModal.DeleteModal.Submit")}
        leftButtonText={t("Groups.GroupModal.DeleteModal.Cancel")}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <Form>
            <Form.Group controlId="formClassName">
              <Form.Label>{t("Groups.GroupModal.Form.GroupName")}</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder={t("Groups.GroupModal.Form.GroupNamePlaceholder")}
                value={this.state.validation.name.value}
                isInvalid={!this.state.validation.name.isValid}
                onChange={this.handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {t("Groups.GroupModal.ValidationError.Name")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <Form.Control
                as="textarea"
                rows={4}
                name="description"
                placeholder={t("Groups.GroupModal.Form.GroupDescriptionPlaceholder")}
                value={this.state.validation.description.value}
                style={{
                  resize: "none",
                  textAlign: "left",
                  paddingLeft: "10px",
                }}
                isInvalid={!this.state.validation.description.isValid}
                onChange={this.handleChange}
              />
            </Form.Group>
            <p>
              {t("Groups.GroupModal.Form.Members")}
              <Badge variant="secondary" className="ml-1">
                {this.state.validation.members.value
                  ? this.state.validation.members.value.length
                  : 0}
              </Badge>
            </p>

            <InputGroup>
              <Col className="p-0">
                <TypeAheadInput
                  validation={this.state.validation}
                  users={this.props.users}
                  handleAddMember={this.handleAddMember}
                  valid={this.state.newMemberValid}
                  emptyLabel={t("Groups.GroupModal.CreateModal.emptyLabel")}
                  promptText={t("Groups.GroupModal.CreateModal.promptText")}
                  placeholder={t("Groups.GroupModal.CreateModal.placeholder")}
                  onSelected={(selected) => {
                    this.setState({
                      newMemberEmail: selected[0],
                    });
                    this.handleCheckEmail(selected[0]);
                  }}
                  clear={this.state.clear}
                  onClear={() =>
                    this.setState({
                      clear: false,
                      newMemberEmail: "",
                      newMemberUserId: "",
                      newMemberValid: false,
                    })
                  }
                />
              </Col>
              <InputGroup.Append>
                <Button
                  variant="btn btn-green"
                  disabled={!this.state.newMemberValid}
                  onClick={this.handleAddMember}
                  style={{
                    borderBottomLeftRadius: "0px",
                    borderTopLeftRadius: "0px",
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </InputGroup.Append>
            </InputGroup>
            <Table size="sm" className="students-table mt-2">
              <thead>
                <tr>
                  <th>{this.props.t("Groups.GroupModal.Form.ColumnEmail")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.validation.members.value.map((m, idx) => (
                  <tr key={idx}>
                    <td>{m.email}</td>
                    <td>
                      <Button
                        className="btn btn-red btn-sm floatRight"
                        onClick={() => this.handleRemoveMember(m)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Form>
        }
      />
    );
  }
}

export default withTranslation()(CreateGroupDialog);
